import { ColumnDef } from '@tanstack/react-table';

import TableCellText from '@/components/atoms/TableCellText';
import { ActivityPoleConditionData } from '@/types/ActivityData';

export const activityTableColumnsColumns: Array<
	ColumnDef<ActivityPoleConditionData>
> = [
	{
		accessorKey: 'activityPoleConditionTrainings',
		id: 'trainingType',
		header: 'Tipo de Treinamento',
		meta: {
			headerClassName: 'bg-gray-100 text-primary text-left px-2 w-36',
		},
		cell: ({ getValue }) => {
			const activityConditionTrainings =
				getValue<ActivityPoleConditionData['activityPoleConditionTrainings']>();
			const trainingType =
				activityConditionTrainings[0]?.training.trainingType ?? 'N/A';
			return (
				<div className="w-36 px-2">
					<TableCellText text={trainingType} />
				</div>
			);
		},

		enableSorting: false,
	},
	{
		accessorKey: 'activityPoleConditionTrainings',
		id: 'training',
		header: 'Treinamento',
		meta: {
			headerClassName: 'bg-gray-100 text-primary text-left px-2 w-[50rem]',
		},
		cell: ({ getValue }) => {
			const activityConditionTrainings =
				getValue<ActivityPoleConditionData['activityPoleConditionTrainings']>();
			const trainings =
				activityConditionTrainings
					?.map((training) => training.training.name)
					.join(', ') ?? 'N/A';

			return (
				<div className="w-[50rem]  overflow-hidden text-ellipsis px-2">
					<TableCellText
						text={trainings}
						className="w-[50rem] overflow-hidden"
					/>
				</div>
			);
		},

		enableSorting: false,
	},
	// {
	//   accessorKey: 'workStations',
	//   header: 'Polo',
	//   meta: {
	//     headerClassName: 'bg-gray-100 text-primary text-left px-2 w-44',
	//   },
	//   cell: ({ getValue }) => {
	//     const workStations = getValue<ActivityPoleConditionData['']>();
	//     const workStationsNames =
	//       workStations
	//         ?.map((workStation) => workStation.workStation.name)
	//         .join(', ') ?? 'N/A';

	//     return (
	//       <div className="w-44 px-2">
	//         <TableCellText text={workStationsNames} />
	//       </div>
	//     );
	//   },

	//   enableSorting: false,
	// },
];
